import React from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';
import { dataModel } from './ratings-and-reviews-data-model';

export const ReviewsLoader = ({ itemId, children }) => {
  const variables = {
    itemId,
    filters: {
      isVerifiedPurchase: false,
      prosCons: null,
      starRatings: null
    },
    searchTerm: null,
    sortBy: 'photoreview',
    startIndex: 1
  };
  const { data, loading, error } = useDataModel('reviews', {
    variables
  });
  return children({
    data,
    loading,
    error
  });
};

ReviewsLoader.dataModel = {
  reviews: dataModel?.reviews
};
